import AtlasLayout from '../../layouts/atlas_layout'

/**
 * The bare map page. It renders nothing of its own: the map, the chrome and the
 * atlas list all belong to the persistent layout, so navigating to a place and
 * back never destroys the MapLibre instance.
 */
export default function Home() {
  return null
}

// A component, not a render function, and the same component the place page will
// assign. Inertia creates the page element with a key and the layout element
// without one, so React preserves this layout instance across visits only while
// both pages resolve to this exact identity.
Home.layout = AtlasLayout
